// Welcher Navigationseintrag ist "aktuell" (UX-Schnitt 2, ST-SEA-001).
//
// EIGENE DATEI und nicht in layout.tsx, damit der Unittest die Regel ohne
// React laden kann; nicht in navigation.ts, weil die Datei einem anderen Strang
// gehoert (Claim ST-TAX-002) und die Regel eine Frage der Darstellung ist.

import type { Screen } from './navigation.ts';

/**
 * Welcher Navigationseintrag ist "aktuell" -- und in welchem Sinn.
 *
 *   'page'   der Eintrag IST der Bildschirm (wie bisher);
 *   'true'   der Bildschirm ist eine UNTERSEITE des Eintrags: sein Pfad
 *            beginnt mit dem Pfad des Eintrags plus "/". Auf
 *            /kontakte/{partyId}/adressen ist das "Kontakte". Ohne diese
 *            Auszeichnung zeigte die Navigation auf jeder Pflegeseite GAR
 *            KEINEN Bereich, und man wuesste nicht, wo man ist (5.2 Nr. 2,
 *            Wegfindung).
 *
 * "true" und nicht "page": die Seite ist nicht die des Eintrags, sie gehoert
 * nur zu ihm. WAI-ARIA sieht "true" genau fuer diesen allgemeinen
 * "aktuell"-Zustand vor; "location" meint Standortpfade (Brotkrumen).
 *
 * NUR WENN ES EINDEUTIG IST: der laengste passende Eintrag gewinnt, und
 * teilen sich zwei denselben laengsten Pfad, bekommt keiner die Auszeichnung
 * -- lieber keine als eine geratene. "/" passt nie, sonst waere "Dein
 * Zugang" der Bereich jeder Seite. Ist der Bildschirm selbst ein Eintrag,
 * bleibt es bei dessen 'page'.
 */
export function navigationCurrent(
  entry: Screen,
  screen: Screen | undefined,
  entries: readonly Screen[],
): 'page' | 'true' | undefined {
  if (screen === undefined) {
    return undefined;
  }
  if (entry.id === screen.id) {
    return 'page';
  }
  if (entries.some((candidate) => candidate.id === screen.id)) {
    return undefined;
  }
  const passend = entries.filter(
    (candidate) => candidate.path !== '/' && screen.path.startsWith(`${candidate.path}/`),
  );
  const laengste = Math.max(0, ...passend.map((candidate) => candidate.path.length));
  const bereich = passend.filter((candidate) => candidate.path.length === laengste);
  return bereich.length === 1 && bereich[0]?.id === entry.id ? 'true' : undefined;
}
